<template>
  <div class="mega-cele pr" style="margin-top: -16px">
    <div class="header-cross pa">
      <i @click="redirectToPreviousPage()" class="jfi-close-v2"></i>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsMutation } from "../helpers/storeKeys";
import PageNames from "../config/pageNames";
import { projectBasePathWithFolder } from "../config/apiEndpoints";
import localStorageFunc from "../helpers/localStorageFunc";

export default defineComponent({
  name: "MegaMilestone",
  props: ["moduleProps"],
  components: {},
  data: () => ({
    modulePropsData: {},
    assetName: "",
  }),
  mounted() {
    const elePgWrapper = document.getElementsByClassName("pg-wrapper")[0];
    const list = elePgWrapper.classList;

    if (elePgWrapper && list) {
      list.add("pb0", "pt0");
    }

    this.modulePropsData =
      this.moduleProps != null &&
      this.moduleProps != "null" &&
      this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    const placeHolderImg_sq = this.modulePropsData?.placeHolder_sq;
    const placeHolderImg_rect = this.modulePropsData?.placeHolder_rect;
    this.$store.commit(keyMapsMutation.UPDATE_PLACE_HOLDER_IMAGE, {
      square: placeHolderImg_sq,
      rect: placeHolderImg_rect,
    });

    let queryParams = Utility.getQueryFromUrl();
    this.assetName = queryParams["fromApp"];
  },
  unmounted() {
    const elePgWrapper = document.getElementsByClassName("pg-wrapper")[0];
    const list = elePgWrapper?.classList;

    if (elePgWrapper && list) {
      list.remove("pb0", "pt0");
    }
  },
  methods: {
    redirectToPreviousPage() {
      const previousLinkRewrite = (
        linkRewrite = LocalStorageFunc.getSessionStorageKey(
          "previousLinkRewrite"
        )
      ) => {
        if (Object.keys(linkRewrite).length <= 0) {
          linkRewrite = PageNames.NEXTGEN_LINKREWRITE_HOME;
        }
        return `/${linkRewrite}/`;
      };

      const actionData = {
        links: [
          {
            title: "Mega Milestone",
            href: "",
            action: "pageClose",
            closeScreen: "true",
          },
        ],
      };

      const url =
        projectBasePathWithFolder +
        previousLinkRewrite() +
        localStorageFunc.storeId() +
        Utility.getUrlQueryString();

      this.redirectPage(url, actionData);
    },
    redirectPage(url, actionData) {
      let assetPrefix;
      if (this.assetName === "ios") {
        assetPrefix = window.webkit.messageHandlers;
      } else if (this.assetName === "android") {
        assetPrefix = window.Android;
      }

      if (this.assetName === "ios") {
        const methodPrefix = assetPrefix["gamifyActions"];
        return methodPrefix["postMessage"](actionData);
      } else if (this.assetName === "android") {
        return window.Android["gamifyActions"](JSON.stringify(actionData));
      } else {
        window.location.href = url;
      }
    },
  },
  computed: {},
});
</script>
